export default __webpack_public_path__ + "static/media/net-icon.a217a370.svg";